import { useState, useEffect, useCallback } from 'react';

const useKeyboardNavigation = (totalRows) => {
  const [focusedCellkey, setFocusedCellkey] = useState({ rowIndex: null, field: null });

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      
      if (focusedCellkey.rowIndex === null || focusedCellkey.field === null) return;
      
      const direction = e.key === 'ArrowDown' ? 1 : -1;
      const nextRowIndex = focusedCellkey.rowIndex + direction;
      
      // Check if next row exists
      if (nextRowIndex >= 0 && nextRowIndex < totalRows) {
        // Find the same field in next/previous row
        const nextInput = document.querySelector(
          `input[data-rowindex="${nextRowIndex}"][data-field="${focusedCellkey.field}"]`
        );
        
        if (nextInput) {
          nextInput.focus();
          nextInput.select();
          
          // Scroll the row into view if needed
          nextInput.closest('tr').scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }
    }
  }, [focusedCellkey, totalRows]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return { focusedCellkey, setFocusedCellkey };
};

export default useKeyboardNavigation;